var map = {
	"./da.json": 4026,
	"./da_DK.json": 3926,
	"./de.json": 2710,
	"./en.json": 1166,
	"./es.json": 1877,
	"./hu.json": 1226,
	"./lt.json": 1545,
	"./pl.json": 6277,
	"./pt.json": 3309,
	"./ro.json": 4258,
	"./sk.json": 4075,
	"./sv.json": 7580,
	"./uk.json": 4525
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5571;